/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminWorkerRunJob,
    AdminWorkerRunJobFromJSON,
    AdminWorkerRunJobFromJSONTyped,
    AdminWorkerRunJobToJSON,
} from './AdminWorkerRunJob';

/**
 * 
 * @export
 * @interface AdminWorkerRunReq
 */
export interface AdminWorkerRunReq {
    /**
     * 
     * @type {AdminWorkerRunJob}
     * @memberof AdminWorkerRunReq
     */
    job: AdminWorkerRunJob;
}



export function AdminWorkerRunReqFromJSON(json: any): AdminWorkerRunReq {
    return AdminWorkerRunReqFromJSONTyped(json, false);
}

export function AdminWorkerRunReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerRunReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'job': AdminWorkerRunJobFromJSON(json['job']),
    };
}

export function AdminWorkerRunReqToJSON(value?: AdminWorkerRunReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job': AdminWorkerRunJobToJSON(value.job),
    };
}

